import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SOSPENSIONE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlSospensioneState extends EntityState<IID_OL_SOSPENSIONE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_SOSPENSIONE })
@InterfaceDataStore(InterfaceName.OLO_SOSPENSIONE)
export class IIDolSospensioneStore extends EntityStore<IIdOlSospensioneState> {
  constructor() {
    super([]);
  }
}
